// redux
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

// Actions
import { loginRequest, setPatient } from "../actions";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  circle: {
    size: 60,
  },
}));

const FormEmailToResetPassword = (props) => {
  const classes = useStyles();

  return (
    <form className={classes.form} noValidate onSubmit={props.handleEmail}>
      <TextField
        error={props.emailValidator}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        type="text"
        id="email"
        label="Escriba su correo electrónico"
        name="email"
        helperText={props.emailValidator && "Debe ingresar un correo válido*"}
        autoFocus
        onChange={props.handleInputEmail}
        value={props.email}
        //disabled={!!props.email}
      />
    </form>
  );
};

const mapStateToProps = (state) => ({
  clinic: state.clinic,
});

const mapDispatchToProps = {
  loginRequest,
  setPatient,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormEmailToResetPassword);
